import { Reveal, Eyebrow, SectionHeading } from "@/components/Reveal";

export function Story() {
  return (
    <section id="story" className="bg-white py-20 lg:py-28" aria-labelledby="story-heading">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid items-center gap-14 lg:grid-cols-2 lg:gap-20">
          <div>
            <Reveal>
              <Eyebrow>The Story</Eyebrow>
              <SectionHeading id="story-heading">Designed by Active Field Professionals</SectionHeading>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-6 text-base leading-relaxed text-slate-600 sm:text-lg">
                VeraChart wasn't built in a tech incubator; it was built in the field. Designed by an active Certified
                Peer Support Specialist and CADC-R with over two years and thousands of hours of experience on a
                community-based ACT team, our prompts are built for the reality of the job.
              </p>
              <p className="mt-4 text-base leading-relaxed text-slate-600">
                We know the difference between a Progress Note and a Visit Attempt. We know exactly what auditors look
                for. We built this system because we needed it ourselves — and now we're sharing it with your team.
              </p>
            </Reveal>
            <Reveal delay={0.16}>
              <blockquote className="mt-8 border-l-4 border-teal-600 pl-6">
                <p className="font-display text-xl font-semibold leading-snug tracking-tight text-navy sm:text-2xl">
                  Stop typing. Start guiding. Own your documentation workflow forever.
                </p>
              </blockquote>
            </Reveal>
          </div>

          <Reveal delay={0.12}>
            <div className="relative">
              <div className="absolute -inset-2 -translate-x-4 translate-y-4 rounded-2xl bg-teal-600/15" aria-hidden="true" />
              <img
                src="https://images.unsplash.com/photo-1507537362848-9c7e70b7b5c1?crop=entropy&cs=srgb&fm=jpg&q=85"
                alt="Two professionals consulting together outdoors in the community"
                loading="lazy"
                className="relative aspect-[4/3] w-full rounded-2xl object-cover shadow-2xl"
              />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
